import type { LucideIcon } from 'lucide-react'
import { cn } from '@/shared/utils/cn'

interface EmptyStateProps {
  icon?: LucideIcon
  title: string
  description?: string
  action?: React.ReactNode
  className?: string
}

export function EmptyState({ icon: Icon, title, description, action, className }: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center text-center',
        className
      )}
    >
      {Icon && <Icon className="mb-3 h-12 w-12 text-ue-text-tertiary" />}
      <p className="text-lg font-medium text-ue-text-primary">{title}</p>
      {description && (
        <p className="mt-1 text-sm text-ue-text-secondary">{description}</p>
      )}
      {action && <div className="mt-4">{action}</div>}
    </div>
  )
}
